/// <reference path="../../_Ext/Editors/BOMGridEditor.ts" />
namespace TabAurous.ECommerce {
    import fld = ECommSalesReturnItemsBOMRow.Fields;
    @Serenity.Decorators.registerClass()

    export class ECommSalesReturnItemsBOMEditor extends _Ext.BOMGridEditor<ECommSalesReturnItemsBOMRow> { 
        protected getDialogType() { return ECommSalesReturnItemsBOMDialog; }
        protected getLocalTextPrefix() { return ECommSalesReturnItemsBOMRow.localTextPrefix; } 
         

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));            
        } 
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        } 
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

    }
}